'use-client';
import {
  BreadcrumbItem as NextUiBreadcrumbItem,
  Breadcrumbs as NextUiBreadcrumbs,
} from '@heroui/react';

export const BreadcrumbItem = NextUiBreadcrumbItem;
export const Breadcrumbs = NextUiBreadcrumbs;
